import React from 'react';
import './style.scss';
import {Grid} from '@material-ui/core'
import { specialOffer,} from '../../assets/images/images'

import {Card, CardContent, } from '@material-ui/core';
import {makeStyles} from '@material-ui/core/styles';
import CardMedia from "@material-ui/core/CardMedia";
import { APP_DOMAIN_PREFIX } from '../../environment';


const useStyles = makeStyles((theme) => ({

  card: {
    // height: '100%',
    display: 'flex',
    flexDirection: 'column',
    cursor:'pointer'
  },
  cardMedia: {
    paddingTop: '56.25%', // 16:9
  },
  cardContent: {
    flexGrow: 0,
    // padding: 0,
  },
  footer: {
    backgroundColor: theme.palette.background.paper,
    padding: theme.spacing(6),
  },
}));

function SellerCard(props) {
  const {data} = props
  const classes = useStyles();
  return (

    <Grid container xs={12} sm={6} md={4} lg={4} direction='column' className='offer-card-container'>
      <Card className={[classes.card, ' card']}>
        <CardMedia
          className={classes.cardMedia}
          image={(data && APP_DOMAIN_PREFIX + data.image) || specialOffer}
          title="Image title"
        />

        <CardContent className={classes.cardContent}>
          <h2 className='text-capitalize  offer-product black-color m-10'>{data.harvest || 'Featured product'}</h2>

          <p className=' offer-des black-color font-16 m-0 mb-10 ml-10 mr-10'>
            {data.promotionDescription}
          </p>

          <p className=' offer-des sub-heading-color font-16 m-0 mb-10 ml-10 mr-10 '>all over the pakistan</p>

          <div className='display-flex align-items-center justify-content-between rate'>
            <div className='rating-container '>
              {/* <button className='display-flex align-items-center '>
                <ShoppingCart/>
                <span className='ml-10 '>Add to cart</span>
              </button> */}
            </div>
            {/* <div className='price-container display-flex align-items-center'>
              <p className='current sub-heading-color text-bold'>Rs25</p>
              <p className='previous in-active-color line-through basic-font ml-10'> Rs25</p>
            </div> */}
          </div>
        </CardContent>
      </Card>
    </Grid>
  );
}

export default SellerCard;
